<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                
                <div class="modal-header">
                    <button type="button" data-dismiss="modal" class="modal-close" aria-label="Cancel" @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <img :src="logoUrl" class="logo" />
                    <h5 class="my-5">Are you sure you want to log out?</h5>
                </div>
                <div class="modal-footer d-flex justify-content-center">
                    <button class="btn btn-confirm" @click="confirmLogout()" data-dismiss="modal">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
const platform = process.env.VUE_APP_Platform ?? "DTN";

export default {
    data(){
        return {
            logoUrl: `/assets/${platform}_Logo.png`,
        }
    },
    methods: {
        ...mapMutations('login',['LOGOUT_USER'],),
        ...mapActions('login', ['updateShowConfirmationLogout']),
        ...mapActions('livePrices', ['setDailyPricesOpenedStatus']),
        confirmLogout: function(){
            this.setDailyPricesOpenedStatus(false)
            this.closeModal()
            this.LOGOUT_USER() // we need to remove session BEFORE calling router
            this.$router.push("/logoutSuccessful")
            this.$cookies.remove("user")
        },
        closeModal: function(){
            this.updateShowConfirmationLogout(false)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>